import React from 'react';
import Icon from '../../../components/AppIcon';

const VersionHistory = ({ versions, onRestore }) => {
  if (!versions?.length) {
    return (
      <div className="text-center py-8 text-gray-400">
        <Icon name="Clock" size={32} className="mx-auto mb-2 opacity-40" />
        <p className="text-sm">No version history yet.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {versions?.map((v, idx) => (
        <div key={v?.id} className="flex items-start justify-between p-4 bg-white border border-gray-200 rounded-lg">
          <div className="flex items-start gap-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
              idx === 0 ? 'bg-accent text-accent-foreground' : 'bg-gray-100 text-gray-600'
            }`}>
              v{v?.version}
            </div>
            <div>
              <div className="flex items-center gap-2">
                <p className="text-sm font-medium text-gray-900">{v?.summary}</p>
                {idx === 0 && (
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">Current</span>
                )}
              </div>
              <p className="text-xs text-gray-500 mt-0.5">{v?.author} &bull; {v?.date}</p>
            </div>
          </div>
          {idx > 0 && (
            <button
              onClick={() => onRestore?.(v)}
              className="text-xs text-accent hover:underline flex items-center gap-1 flex-shrink-0 ml-3"
            >
              <Icon name="RotateCcw" size={12} />
              Restore
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default VersionHistory;
